<section class="page-hero">
  <div class="hero-copy">
    <p class="eyebrow">FAQ</p>
    <h1>Ambassador program questions.</h1>
    <p class="lede">Program details are finalized during approval and may vary by market, plan, and campaign.</p>
  </div>
</section>
<section class="content-section faq-list">
  <article>
    <h3>When do I get paid?</h3>
    <p>Eligible commissions are reviewed after subscription billing and paid monthly once payout thresholds are met.</p>
  </article>
  <article>
    <h3>Can I advertise worldwide?</h3>
    <p>Yes, unless your approval terms or local rules limit specific regions, channels, or claims.</p>
  </article>
  <article>
    <h3>Do I need a company?</h3>
    <p>No. Companies and individuals can apply, although payout and tax details may differ.</p>
  </article>
  <article>
    <h3>Can individuals join?</h3>
    <p>Yes. Individual creators, instructors, and community members are welcome when they have a relevant boating
      audience.</p>
  </article>
  <article>
    <h3>Minimum payout?</h3>
    <p>A minimum payout amount may apply so small balances roll forward until the threshold is reached.</p>
  </article>
  <article>
    <h3>How are refunds handled?</h3>
    <p>Refunded or disputed subscriptions can be excluded from commission or clawed back from future payouts.</p>
  </article>
  <article>
    <h3>How long is a referral valid?</h3>
    <p>Referral links use a defined attribution period, confirmed in your ambassador terms.</p>
  </article>
  <article>
    <h3>Can multiple ambassadors claim the same customer?</h3>
    <p>No. YachtApp applies attribution rules so one eligible ambassador owns the tracked conversion.</p>
  </article>
</section>